import { InputAgreementFileToUpload } from '../../models/front-dto/api.dto';
export class InputAgreement {
    house_id: number;
    supplier_partner_id: number;
    input_agreement_file_to_upload: InputAgreementFileToUpload;
}